const TOAST_TIMEOUT = 5000;

export { TOAST_TIMEOUT };
